{
  "Login": "Inloggen",
  "Local Login": "Lokale Inloggen",
  "email": "e-mail",
  "password": "wachtwoord"
}